/* ============================================
   ProFRSH Header - Sticky, Transparent, Mobile
   ============================================ */
window.Profrsh = window.Profrsh || {};

Profrsh.Header = class {
  constructor() {
    this.header = document.querySelector('[data-header]');
    if (!this.header) return;

    this.isSticky = this.header.dataset.sticky === 'true';
    this.isTransparent = this.header.dataset.transparent === 'true';
    this.scrollThreshold = 50;
    this.isScrolled = false;

    /* Announcement bar offset */
    this.announcementBar = document.querySelector('.announcement-bar');
    this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
    if (this.announcementBarHeight > 0) {
      document.documentElement.style.setProperty('--header-top-offset', this.announcementBarHeight + 'px');
    }

    /* Mobile menu */
    this.menuToggle = this.header.querySelector('[data-mobile-menu-toggle]');
    this.mobileMenu = document.querySelector('[data-mobile-menu]');

    this.bindEvents();
    this.onScroll();
  }

  bindEvents() {
    /* Scroll handler */
    if (this.isSticky || this.isTransparent) {
      window.addEventListener('scroll', Profrsh.throttle(() => this.onScroll(), 50), { passive: true });
    }

    /* Mobile menu toggle */
    if (this.menuToggle && this.mobileMenu) {
      this.menuToggle.addEventListener('click', () => this.toggleMobileMenu());

      /* Mobile menu overlay close */
      const overlay = this.mobileMenu.querySelector('.mobile-menu__overlay');
      if (overlay) overlay.addEventListener('click', () => this.closeMobileMenu());

      /* Mobile menu close button */
      this.mobileMenu.querySelectorAll('[data-mobile-menu-close]').forEach(btn => {
        btn.addEventListener('click', () => this.closeMobileMenu());
      });

      /* Mobile submenu toggles */
      this.mobileMenu.querySelectorAll('.mobile-menu__link--parent').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleSubmenu(btn);
        });
      });
    }

    /* Desktop mega menu hover intent */
    this.header.querySelectorAll('.header-nav__item--has-children').forEach(item => {
      let timeout;
      item.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        item.classList.add('is-active');
      });
      item.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => item.classList.remove('is-active'), 150);
      });
    });

    /* ESC to close mobile menu */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.mobileMenu?.classList.contains('is-open')) {
        this.closeMobileMenu();
      }
    });
  }

  onScroll() {
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldBeScrolled = scrollY > this.scrollThreshold;

    if (shouldBeScrolled !== this.isScrolled) {
      this.isScrolled = shouldBeScrolled;
      this.header.classList.toggle('site-header--scrolled', this.isScrolled);
    }

    /* Adjust header offset when announcement bar scrolls out of view */
    if (this.announcementBarHeight > 0) {
      const offset = Math.max(0, this.announcementBarHeight - scrollY);
      document.documentElement.style.setProperty('--header-top-offset', offset + 'px');
    }
  }

  toggleMobileMenu() {
    if (this.mobileMenu.classList.contains('is-open')) {
      this.closeMobileMenu();
    } else {
      this.openMobileMenu();
    }
  }

  openMobileMenu() {
    this.mobileMenu.removeAttribute('hidden');
    requestAnimationFrame(() => {
      this.mobileMenu.classList.add('is-open');
      this.menuToggle.setAttribute('aria-expanded', 'true');
      Profrsh.pauseBodyScroll();
      const panel = this.mobileMenu.querySelector('.mobile-menu__panel');
      if (panel) Profrsh.trapFocus(panel);
    });
  }

  closeMobileMenu() {
    this.mobileMenu.classList.remove('is-open');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    Profrsh.resumeBodyScroll();
    setTimeout(() => {
      if (!this.mobileMenu.classList.contains('is-open')) {
        this.mobileMenu.setAttribute('hidden', '');
      }
    }, 400);
  }

  toggleSubmenu(btn) {
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';
    const submenu = btn.nextElementSibling;
    if (!submenu) return;

    btn.setAttribute('aria-expanded', !isExpanded);
    submenu.classList.toggle('is-open', !isExpanded);
  }
};

document.addEventListener('DOMContentLoaded', () => {
  new Profrsh.Header();
});
